module.exports = __webpack_public_path__ + "static/media/sc17.23.12441c8e.mp4";